// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, Input } from '@angular/core';
import { TenantService } from '../../../services/tenant.service';

@Component({
  selector: 'kith-kin',
  standalone: false,
  templateUrl: './kith-kin.component.html',
  styleUrl: './kith-kin.component.css'
})
export class KithKinComponent {
  @Input('menuItems') menuItems: any[] = [];

  constructor(public tenantService: TenantService) { }
}
